$(function() {
    var reminds_opening_at = $('#reminds_opening_at');
    var imports_data_at = $('#imports_data_at');
    var opens_at = $('#opens_at');
    var sdm_notifications = $('#sdm_notifications');
    var dealer_group_notifications = $('#dealer_group_notifications');
    var reminds_closing_at = $('#reminds_closing_at');
    var closes_at = $('#closes_at');
    var sdm_closes_at = $('#sdm_closes_at');
    var form = $('.forecast-create form');

    flatpickr(".BothPicker", {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
    });

    form.submit(function(e){
        var error = 0
        
        if(!reminds_opening_at.val()) {
            reminds_opening_at.addClass('__error');
            reminds_opening_at.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            reminds_opening_at.removeClass('__error');
            reminds_opening_at.siblings('.forecast-error').text("");
        }

        if(!imports_data_at.val()) {
            imports_data_at.addClass('__error');
            imports_data_at.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            imports_data_at.removeClass('__error');
            imports_data_at.siblings('.forecast-error').text("");
        }

        if(!opens_at.val()) {
            opens_at.addClass('__error');
            opens_at.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            opens_at.removeClass('__error');
            opens_at.siblings('.forecast-error').text("");
        }

        if(!sdm_notifications.val()) {
            sdm_notifications.addClass('__error');
            sdm_notifications.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            sdm_notifications.removeClass('__error');
            sdm_notifications.siblings('.forecast-error').text("");
        }

        if(!dealer_group_notifications.val()) {
            dealer_group_notifications.addClass('__error');
            dealer_group_notifications.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            dealer_group_notifications.removeClass('__error');
            dealer_group_notifications.siblings('.forecast-error').text("");
        }

        if(!reminds_closing_at.val()) {
            reminds_closing_at.addClass('__error');
            reminds_closing_at.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            reminds_closing_at.removeClass('__error');
            reminds_closing_at.siblings('.forecast-error').text("");
        }

        if(!closes_at.val()) {
            closes_at.addClass('__error');
            closes_at.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            closes_at.removeClass('__error');
            closes_at.siblings('.forecast-error').text("");
        }

        if(!sdm_closes_at.val()) {
            sdm_closes_at.addClass('__error');
            sdm_closes_at.siblings('.forecast-error').text('Required');
            error = 1;
        } else {
            sdm_closes_at.removeClass('__error');
            sdm_closes_at.siblings('.forecast-error').text("");
        }

        if( reminds_opening_at.val() && opens_at.val()) {
            if( new Date(reminds_opening_at.val()) > new Date(opens_at.val())) {
                reminds_opening_at.addClass('__error');
                reminds_opening_at.siblings('.forecast-error').text('Reminder must be before opening time');
                error = 1;
            } else {
                reminds_opening_at.removeClass('__error');
                reminds_opening_at.siblings('.forecast-error').text("");
            }
        }

        if( imports_data_at.val() && opens_at.val()) {
            if( new Date(imports_data_at.val()) > new Date(opens_at.val())) {
                imports_data_at.addClass('__error');
                imports_data_at.siblings('.forecast-error').text('Import must be before opening time');
                error = 1;
            } else {
                imports_data_at.removeClass('__error');
                imports_data_at.siblings('.forecast-error').text("");
            }
        }

        if( sdm_closes_at.val() && opens_at.val()) {
            if( new Date(opens_at.val()) > new Date(sdm_closes_at.val())) {
                opens_at.addClass('__error');
                opens_at.siblings('.forecast-error').text('Opens at must be a date before closes at');
                error = 1;
            } else {
                opens_at.removeClass('__error');
                opens_at.siblings('.forecast-error').text("");
            }
        }

        if( closes_at.val() && opens_at.val()) {
            if( new Date(opens_at.val()) > new Date(closes_at.val())) {
                opens_at.addClass('__error');
                opens_at.siblings('.forecast-error').text('Opens at must be a date before closes at');
                error = 1;
            } else {
                opens_at.removeClass('__error');
                opens_at.siblings('.forecast-error').text("");
            }
        }

        if( sdm_notifications.val() && opens_at.val()) {
            if( new Date(opens_at.val()) > new Date(sdm_notifications.val())) {
                sdm_notifications.addClass('__error');
                sdm_notifications.siblings('.forecast-error').text('The sdm notifications at must be a date after opens at');
                error = 1;
            } else {
                sdm_notifications.removeClass('__error');
                sdm_notifications.siblings('.forecast-error').text("");
            }
        }

        if( dealer_group_notifications.val() && opens_at.val()) {
            if( new Date(opens_at.val()) > new Date(dealer_group_notifications.val())) {
                dealer_group_notifications.addClass('__error');
                dealer_group_notifications.siblings('.forecast-error').text('The dealer group notifications at must be a date after opens at');
                error = 1;
            } else {
                dealer_group_notifications.removeClass('__error');
                dealer_group_notifications.siblings('.forecast-error').text("");
            }
        }

        if( reminds_closing_at.val() && closes_at.val()) {
            if( new Date(reminds_closing_at.val()) > new Date(closes_at.val())) {
                reminds_closing_at.addClass('__error');
                reminds_closing_at.siblings('.forecast-error').text('The closing reminder at must be a date before closes at');
                error = 1;
            } else {
                reminds_closing_at.removeClass('__error');
                reminds_closing_at.siblings('.forecast-error').text("");
            }
        }

        if(error) {
            e.preventDefault();
        }
    });
});